/**
 * TutorialHints — pure state machine for Stage 1 tutorial hint overlay.
 * No Phaser import. Tracks which of the three intro hints have been triggered.
 */

export type HintId = 'LIGHT' | 'HEAVY' | 'SPECIAL';

export interface HintDef {
  id: HintId;
  /** Ghost text displayed on-screen. */
  label: string;
}

export const HINT_DEFS: readonly HintDef[] = [
  { id: 'LIGHT', label: 'Tap LIGHT (J)' },
  { id: 'HEAVY', label: 'Hold HEAVY (K)' },
  { id: 'SPECIAL', label: 'SPECIAL (L) ↑ for star' },
];

export class TutorialHintsManager {
  private readonly completed = new Set<HintId>();

  /**
   * Mark a hint as completed. Returns true if newly completed
   * (i.e. the hint should now fade out in the UI).
   */
  complete(id: HintId): boolean {
    if (this.completed.has(id)) return false;
    this.completed.add(id);
    return true;
  }

  isCompleted(id: HintId): boolean {
    return this.completed.has(id);
  }

  get allDone(): boolean {
    return this.completed.size >= HINT_DEFS.length;
  }

  /** Hints not yet completed. */
  get activeHints(): readonly HintDef[] {
    return HINT_DEFS.filter((h) => !this.completed.has(h.id));
  }
}
